// noinspection DuplicatedCode

import React, {useEffect, useState} from "react";

import {Colors} from "../../assets/Colors";
import {fetchGet, fetchPost, fetchPut} from "../../fetchers";
import {useMutation} from "@tanstack/react-query";
import {DynamicTableSimple} from "../../components/tablecard/DynamicTable";
import {Card} from "@material-tailwind/react";
import {isRequired, useForm} from "../../components/isRequired";
import Modal from "@material-tailwind/react/Modal";
import ModalHeader from "@material-tailwind/react/ModalHeader";
import ModalBody from "@material-tailwind/react/ModalBody";
import {HrdInputGenerator} from "../../components/form/HrdInputGenerator";
import ModalFooter from "@material-tailwind/react/ModalFooter";
import Button from "@material-tailwind/react/Button";
import 'react-toastify/dist/ReactToastify.css';
import {BiArrowBack} from "react-icons/bi";
import {useLocation, useNavigate, useParams} from "react-router-dom";
import {toast} from "react-toastify";

const Closing = ({}) => {
    let initialState = {
        BisnisUnitID: "",
        Tanggal: new Date()
    };

    let initialStateModal = {
        SDTDate: new Date(),
        Bulan: new Date(),
        Tahun: new Date().getFullYear().toString(),
        Keterangan: "",
        Pelaksana: "",
        Debet: 0,
        Kredit: 0
    };
    const validations = [(
        {UserPCName}) => isRequired(UserPCName) || {UserPCName: "Nama UserPC wajib diisi"}, ({Status}) => isRequired(Status) || {Status: "Status wajib diisi"},
        ({KelompokID}) => isRequired(KelompokID) || {KelompokID: "Kelompok wajib diisi"}, ({Status}) => isRequired(Status) || {Status: "Kelompok wajib diisi"},
        ({DetailAccountID}) => isRequired(DetailAccountID) || {DetailAccountID: "Detail Account wajib diisi"}, ({Status}) => isRequired(Status) || {Status: "Detail Account wajib diisi"},
    ];

    const {
        changed,
        values,
        isValid,
        touched,
        submitHandler,
        customHandler,
        changeHandler,
        errors,
        blastChange
    } = useForm(initialState, validations);


    const barang = useMutation(formData => fetchGet("Master/Barang/min"))
    const [buttonTouched, setButtonTouched] = useState(false);
    const [detail, setDetail] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [showModalEdit, setShowModalEdit] = useState(false);
    const [modalDetail, setModalDetail] = useState(initialStateModal);
    const [modalID, setModalID] = useState(0);
    const ModalOpener = (detail) => {
        setShowModal(true)
    }
    const param = useLocation();
    const params = useParams();

    const mutation = useMutation(formData => fetchPost("Master/UserPC", formData))
    const mutationAdd = useMutation(formData => fetchPost("Accounting", formData))
    const mutationGet = useMutation(formData => fetchGet("Accounting/" + formData))
    const mutationUpdate = useMutation(formData => fetchPut("Accounting", formData))

    const ModalEdit = (detail, id) => {
        setModalID(id)
        setModalDetail(detail)
        setShowModal(true)
        setShowModalEdit(true)
    }

    const ModalDelete = (id) => {
        let newDetail = [...detail]
        newDetail.splice(id, 1);
        setDetail(newDetail)
    }

    const navigate = useNavigate();

    useEffect(() => {
        barang.mutate()
        if (params.transid) {
            mutationGet.mutate(params.transid)
        }

    }, []);

    useEffect(() => {
        if (mutationUpdate) {
            if (mutationUpdate.isSuccess) {
                navigate("/accounting/jurnal")
            }
        }
    }, [mutationUpdate.status]);


    useEffect(() => {
        if (mutationAdd) {
            if (mutationAdd.isSuccess) {
                navigate("/accounting/jurnal")
            }
        }
    }, [mutationAdd.status]);

    useEffect(() => {
        if (mutationGet.data) {
            setDetail(mutationGet.data.data[0].Data)
            let tempData = mutationGet.data.data[0]

            blastChange(tempData)
        }
    }, [mutationGet.status]);

    const header = [
        {name: "Bulan", key: "Bulan", modifiers: "text"},
        {name: "Tahun", key: "Tahun", modifiers: "text"},
        {name: "Keterangan", key: "Keterangan", modifiers: "text"},
        {name: "Pelaksana", key: "Pelaksana", modifiers: "text"},
    ]

    const modalHandler = (value, names) => {
        const newValues = {...modalDetail, [names]: value};
        setModalDetail(newValues);
    };

    const modalHandlerWithBody = (value) => {
        const newValues = {...modalDetail, ["NomorAccount"]: value.value, ["NamaAccount"]: value.label};
        setModalDetail(newValues);
    };

    const modalHandlerText = (event) => {
        const newValues = {...modalDetail, [event.target.name]: event.target.value};
        setModalDetail(newValues);
    };
    const modalHandlerTextgen2 = (event) => {
        let valuetemp = event.target.value.replaceAll(".", "")
        const newValues = {...modalDetail, [event.target.name]: valuetemp};
        setModalDetail(newValues);
    };
    const inputBuilder = [
        {
            type: "bulan",
            name: "Bulan",
            title: "Bulan",
            handler: modalHandler,
            size: "full",
            required: true,
            disabled: false,
            edit: false
        },
        {
            type: "text",
            name: "Tahun",
            title: "Tahun",
            handler: modalHandlerText,
            size: "full",
            required: true,
            disabled: false,
            edit: false
        },
        {
            type: "text",
            name: "Keterangan",
            title: "Keterangan",
            handler: modalHandlerText,
            size: "full",
            required: false,
            disabled: false,
            edit: false
        },
        {
            type: "text",
            name: "Pelaksana",
            title: "Pelaksana",
            handler: modalHandlerText,
            size: "full",
            required: false,
            disabled: false,
            edit: false
        },
    ]


    const Kirim = () => {
        let newValues = values;
        try {
            newValues["Tanggal"] = newValues["Tanggal"].toISOString()
            newValues["Nominal"] = newValues["Nominal"].toString()
        } catch (err) {
        }

        newValues["Data"] = detail
        let jumlahK = 0
        let jumlahD = 0
        detail.map((isi, id) => {
            jumlahK += parseFloat(isi["Kredit"])
            jumlahD += parseFloat(isi["Debet"])
        })
        if (jumlahK !== jumlahD) {
            toast.error('Data tidak balance', {
                position: "bottom-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: true,
                progress: undefined,
                theme: "light",
            })
        } else {
            if (params.transid) {
                newValues["Status"] = "1"
                mutationUpdate.mutate(newValues)
            } else {
                mutationAdd.mutate(newValues)
            }
        }
    }


    return (<div className="md:ml-64">
        <div
            style={{background: Colors.primary}}
            className="pt-14 pb-16 px-3 md:px-8 h-auto"
        >
            <div className="container mx-auto max-w-full">
                <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-4"></div>
            </div>
        </div>
        <div className="px-3 md:px-8 h-auto -mt-32">
            <div className="container mx-auto max-w-full">
                <div className="grid grid-cols-1 px-4">
                    <Card>
                        <div className="flex flex-col  mt-5">
                            <div className="flex w-full justify-end flex-col sm:flex-row ">
                                <button
                                    onClick={() => navigate("/accounting/jurnal")}
                                    className="flex flex-row items-center justify-center m-2 sm:my-0 bg-white hover:bg-main-100 hover:text-white text-gray-800 font-semibold py-2 px-4 border border-main-100 shadow rounded"
                                >
                                    <BiArrowBack className="text-xl text-gray-800 pr-2"/>
                                    Kembali
                                </button>

                            </div>
                            <div className="w-1/3">
                                <HrdInputGenerator type={"BisnisUnit"} value={values} name={"BisnisUnitID"}
                                                   title={"Bisnis Unit"}
                                                   onChange={customHandler} touched={touched}
                                                   buttonTouched={buttonTouched}
                                                   size={"full"}
                                                   required={true} errors={errors}
                                                   disabled={false}
                                />
                            </div>


                            <hr/>
                            <DynamicTableSimple data={detail}
                                                header={header}
                                                Master={true}
                                                OnClick={ModalOpener}
                                                name={"Purchase Requisition"}
                                                barang={barang.data}
                                                edit={ModalEdit}
                                                delete={ModalDelete}
                            />
                        </div>
                    </Card>
                    <Modal
                        size="lg"
                        active={showModal}
                        toggler={() => {
                            setShowModal(false);
                            setShowModalEdit(false);
                        }}
                    >
                        <ModalHeader
                            className="mt-20"
                            toggler={() => {
                                setShowModal(false);
                                setShowModalEdit(false);
                            }}
                        >

                            {showModalEdit ? "Edit Data" : "Tambah Data"}
                        </ModalHeader>
                        <ModalBody>
                            <form className="w-full " onSubmit={submitHandler}>
                                {inputBuilder.map(({
                                                       type,
                                                       name,
                                                       title,
                                                       handler,
                                                       modifiers,
                                                       size,
                                                       required,
                                                       disabled,
                                                       edit,
                                                   }, id) => {
                                    if (!edit || showModalEdit) {
                                        return (
                                            <HrdInputGenerator key={name} type={type} value={modalDetail} name={name} title={title}
                                                               onChange={handler} touched={touched}
                                                               buttonTouched={buttonTouched}
                                                               modifiers={modifiers} size={size}
                                                               required={required} errors={errors}
                                                               disabled={disabled}
                                            />
                                        )
                                    }
                                })}
                            </form>
                            Proses ini akan memakan waktu 5-10 menit harap tidak menutup tab ini
                        </ModalBody>
                        <ModalFooter>
                            <Button
                                color="red"
                                buttonType="link"
                                onClick={() => {
                                    setShowModal(false);
                                    setShowModalEdit(false);
                                }}
                                ripple="dark"
                            >
                                Cancel
                            </Button>

                            <Button
                                color={(isValid || (!isValid)) ? "green" : "blueGray"}
                                disabled={mutation.isLoading}
                                onClick={() => {
                                    if (!isValid && changed) {
                                        setButtonTouched(true);
                                    }
                                    let tempIsValid = isValid;
                                    if (!isValid) {
                                    }
                                    // Konversi Bulan (Date object) ke string sebelum disimpan ke tabel
                                    const bulanStr = modalDetail.Bulan instanceof Date
                                        ? (modalDetail.Bulan.getMonth() + 1) + "/" + modalDetail.Bulan.getFullYear()
                                        : String(modalDetail.Bulan || "");
                                    const itemToSave = {
                                        ...modalDetail,
                                        Bulan: bulanStr,
                                        Debet: parseFloat(modalDetail.Debet) || 0,
                                        Kredit: parseFloat(modalDetail.Kredit) || 0,
                                    };
                                    if (showModalEdit) {
                                        const newValues = [...detail];
                                        newValues[modalID] = itemToSave;
                                        setDetail(newValues);
                                        setModalDetail(initialStateModal);
                                        setShowModal(false);
                                        setShowModalEdit(false);
                                    } else {
                                        setDetail([...detail, itemToSave]);
                                        setModalDetail(initialStateModal);
                                    }
                                }}
                                ripple={isValid ? "light" : ""}
                            >
                                {showModalEdit ? "Ubah" : "Closing"}
                            </Button>
                        </ModalFooter>
                    </Modal>
                </div>
            </div>
        </div>
    </div>);
};

export default Closing;
